"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetSurveyParticipantsParams () {
        return GetSurveyParticipantsParams;
    },
    get GetSurveyParticipantsQuery () {
        return GetSurveyParticipantsQuery;
    },
    get GetSurveyParticipantsResponse () {
        return GetSurveyParticipantsResponse;
    },
    get SurveyParticipantWithSubmittedAt () {
        return SurveyParticipantWithSubmittedAt;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetSurveyParticipantsParams = _zod.z.object({
    surveyId: _utilsisomorphic.transformObjectId
});
const GetSurveyParticipantsQuery = _zod.z.object({
    search: _zod.z.string().optional(),
    sort: _zod.z.enum([
        "asc",
        "desc"
    ]).optional(),
    limit: _zod.z.coerce.number().optional(),
    offset: _zod.z.coerce.number().optional()
});
const SurveyParticipantWithSubmittedAt = _models.SurveyParticipantModel.extend({
    submittedAt: _utilsisomorphic.transformDate
});
const GetSurveyParticipantsResponse = _zod.z.object({
    participants: _zod.z.array(SurveyParticipantWithSubmittedAt),
    total: _zod.z.number(),
    limit: _zod.z.number(),
    offset: _zod.z.number()
});
